module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.conditionToShow('request')) ? _c('b', {
    staticClass: "showMoreData",
    staticStyle: {
      "color": "red"
    },
    on: {
      "click": function($event) {
        _vm.handleAction('1')
      }
    }
  }, [_vm._v("\n        Request To Delete Assignment\n    ")]) : _vm._e(), _vm._v(" "), (_vm.conditionToShow('sentApproval')) ? _c('b', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n        Sent For Delete Approval\n    ")]) : _vm._e(), _vm._v(" "), (_vm.conditionToShow('approve') &&
    _vm.$sessionsStorage.get('designation') == 'Admin' &&
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh') ? _c('b', {
    staticClass: "showMoreData",
    staticStyle: {
      "color": "red"
    },
    on: {
      "click": function($event) {
        _vm.handleAction('2')
      }
    }
  }, [_vm._v("\n        Approve Delete Request /\n    ")]) : _vm._e(), _vm._v(" "), (_vm.conditionToShow('reject') &&
    _vm.$sessionsStorage.get('designation') == 'Admin' &&
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh') ? _c('b', {
    staticClass: "showMoreData",
    staticStyle: {
      "color": "red"
    },
    on: {
      "click": function($event) {
        _vm.handleAction('3')
      }
    }
  }, [_vm._v("\n        Reject Delete Request\n    ")]) : _vm._e(), _vm._v(" "), (_vm.conditionToShow('delete') &&
    _vm.$sessionsStorage.get('designation') == 'Admin' &&
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh') ? _c('b', {
    staticClass: "showMoreData",
    staticStyle: {
      "color": "red"
    },
    on: {
      "click": function($event) {
        _vm.handleAction('4')
      }
    }
  }, [_vm._v("\n        Delete Assignment\n    ")]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "modal-AssRemove-conf",
    attrs: {
      "id": "modal-AssRemove-conf",
      "title": "Confirmation Remove Assignment",
      "centered": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "error",
    attrs: {
      "md": "12",
      "align": "center"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.PaymentType))])])], 1), _vm._v(" "), _c('b-button', {
    staticClass: "pull-left",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.closeModalRemoveAss
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.execActions(_vm.PaymentTypeModuleId, _vm.PaymentTypeID, _vm.PaymentTypeJOBNo)
      }
    }
  }, [_vm._v("\n            Yes")])], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopMail",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAction
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopApprove",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAction
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopReject",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAction
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopDelete",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAction
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dcbeb058","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/MSDeleteRequest.vue
// module id = 2881
// module chunks = 0